import {useCallback} from 'react';
import {autoFitScale} from '~/common/utils/autoFitScale';

export const useImageReset = (canvas) => {
  const resetImage = useCallback(() => {
    const activeObj = canvas?.getActiveObject();
    if (activeObj && activeObj.type === 'uYOImage') {
      const rect = canvas
        .getObjects()
        .find((obj) => obj.type === 'rect' && obj.id === activeObj.id);

      if (rect) {
        const effectiveWidth = rect.width * rect.scaleX;
        const effectiveHeight = rect.height * rect.scaleY;
        const scaleX = effectiveWidth / activeObj.width;
        const scaleY = effectiveHeight / activeObj.height;
        const scale = autoFitScale(activeObj, rect) || Math.min(scaleX, scaleY);
        const centerX = rect.left + (rect.width * rect.scaleX) / 2;
        const centerY = rect.top + (rect.height * rect.scaleY) / 2;

        activeObj.scale(scale).set({
          left: centerX,
          top: centerY,
          originX: 'center',
          originY: 'center',
          centeredRotation: true,
          hasControls: true,
          angle: 0,
          flipX: false,
          flipY: false,
        });

        if (activeObj.filters.length > 0) {
          activeObj.filters = [];
          activeObj.applyFilters();
        }

        canvas.setActiveObject(activeObj);
        canvas.renderAll();
        canvas.fire('object:modified');
        canvas.fire('object:reseted:uyo');

        return true;
      }
    }

    return false;
  }, [canvas]);

  return {resetImage};
};
